import OwlCarousel from 'react-owl-carousel'
import React from 'react'
import img1 from '../../../assets/companies/bp.png'
import img3 from '../../../assets/companies/blohmvoss.png'
import img4 from '../../../assets/companies/britcham.png'
import img5 from '../../../assets/companies/enquest.png'
import img6 from '../../../assets/companies/hie.png'
import img7 from '../../../assets/companies/modec.png'
import img8 from '../../../assets/companies/mpi.png'
import img9 from '../../../assets/companies/nepic.png'
import img10 from '../../../assets/companies/nof.png'
import img11 from '../../../assets/companies/oilserv.png'
import img12 from '../../../assets/companies/penspen.png'
import img13 from '../../../assets/companies/petrofac.png'
import img14 from '../../../assets/companies/scottishenterprise.png'
import img15 from '../../../assets/companies/woodgroup.png'

const Main = () => {
    const company_slider = {
        loop:true,
        margin:10,
        nav:false,
        autoplay: true,
        smartSpeed: 1500,
        dots: true, 
        responsive:{
            0:{
                items:2
            },
            600:{
                items:3
            },
            1000:{
                items:5
            }
        }
    }

  return (
    <>
        <section className="row_am trusted_section">
            <div className="container">
                <div className="section_title"  data-aos-duration="1500" data-aos-delay="100">
                <h2>Trusted by </h2>
                <p>Take a look at the companies we have worked with, we provide solutions for a range of businesses from SME to Enterprise.</p>
                </div>
                <div className="company_logos" >
                <OwlCarousel id="company_slider" {...company_slider} className="owl-carousel owl-theme owl-loaded owl-drag">
                    <div className="item">
                    <div className="logo">
                        <img src={img1} alt="bp" />
                    </div>
                    </div>
                    <div className="item">
                    <div className="logo">
                        <img src={img3} alt="blohmvoss" />
                    </div>
                    </div>
                    <div className="item">
                    <div className="logo">
                        <img src={img4} alt="britcham" />
                    </div>
                    </div>
                    <div className="item">
                    <div className="logo">
                        <img src={img5} alt="enquest" />
                    </div>
                    </div>
                    <div className="item">
                    <div className="logo">
                        <img src={img6} alt="hie" />
                    </div>
                    </div>
                    <div className="item">
                    <div className="logo">
                        <img src={img7} alt="modec" />
                    </div>
                    </div>
                    <div className="item">
                    <div className="logo">
                        <img src={img8} alt="mpi" />
                    </div>
                    </div>
                    <div className="item">
                    <div className="logo">
                        <img src={img9} alt="nepic" />
                    </div>
                    </div>
                    <div className="item">
                    <div className="logo">
                        <img src={img10} alt="nof" />
                    </div>
                    </div>
                    <div className="item">
                    <div className="logo">
                        <img src={img11} alt="oilserv" />
                    </div>
                    </div>
                    <div className="item">
                    <div className="logo">
                        <img src={img12} alt="penspen" />
                    </div>
                    </div>
                    <div className="item">
                    <div className="logo">
                        <img src={img13} alt="petrofac" />
                    </div>
                    </div>
                    <div className="item">
                    <div className="logo">
                        <img src={img14} alt="scottishenterprise" />
                    </div>
                    </div>
                    <div className="item">
                    <div className="logo">
                        <img src={img15} alt="woodgroup" />
                    </div>
                    </div>
                </OwlCarousel>
                </div>
            </div>
        </section>
    </>
  )
}

export default Main